import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import _ from 'lodash'
// import cn from 'classnames'
import './Upload.scss';

import UploadDropzone from '../components/Uploads/UploadDropzone';
import UploadResults from '../components/Uploads/UploadResults';

const Upload = (props) => {
  const [uploads, setUploads] = useState([]);

  useEffect(() => {
    window.__ADD_EVENT__('Upload - Page View');
  }, []);

  return (
    <div className='upload-outer-container'>
      <div className='upload-inner-container'>
        <div className='upload-dropzone-container'>
          <UploadDropzone user={props.user} uploads={uploads} setUploads={(vals) => setUploads(vals)} />
        </div>
        {!!uploads.length && <UploadResults setUploads={(vals) => setUploads(vals)} uploads={uploads} />}
      </div>
    </div>
  );
};

Upload.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  // functions go here
})(Upload);
